'use client';

import { cn } from '@/lib/utils';

interface SectionHeaderProps {
  label: string;
  title: string;
  className?: string;
  variant?: 'default' | 'light';
}

export function SectionHeader({
  label,
  title,
  className,
  variant = 'default',
}: SectionHeaderProps) {
  const labelColor = variant === 'light' 
    ? 'text-brand-violet-100' 
    : 'text-brand-violet-300';

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <p className={cn('text-xs font-normal uppercase', labelColor)}>
        {label}
      </p>
      <h2 className="text-white text-[2.5rem] lg:text-[3rem] font-semibold leading-tight">
        {title}
      </h2>
    </div>
  );
}

